import React from 'react';
import { Modal } from 'react-bootstrap';
import '../styles/EulaModal.css';

const SBMSAccessModal = ({ show, onHide }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            backdrop="static"
            keyboard={false}
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        >
            <Modal.Header closeButton className="bg-dark text-white border-0" data-bs-theme="dark">
                <Modal.Title>Access to SBMS is restricted.</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark text-white">
                <p>If you are affiliated with the U.S. Department of Defense or currently hold an active DoD contract, please contact us at <a href="mailto:spacecockpit@saberastro.com" style={{ color: '#f5bc59' }}>spacecockpit@saberastro.com</a> to request account whitelisting.</p>
                <p>All other users must obtain a valid license to access SBMS. For licensing information or to request access, please reach out to us at <a href="mailto:spacecockpit@saberastro.com" style={{ color: '#f5bc59' }}>spacecockpit@saberastro.com</a></p>
            </Modal.Body>
        </Modal>
    );
};

export default SBMSAccessModal; 